import { render, staticRenderFns } from "./yi_data_select.vue?vue&type=template&id=34428efc&"
import script from "./yi_data_select.vue?vue&type=script&lang=js&"
export * from "./yi_data_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports